/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Type_Any_ChangeInputs */

const he_notifications_type_any_change = /** @type {(inputs: Notifications_Type_Any_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כל שינוי במחיר`)
};

const en_notifications_type_any_change = /** @type {(inputs: Notifications_Type_Any_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any Price Change`)
};

/**
* | output |
* | --- |
* | "Any Price Change" |
*
* @param {Notifications_Type_Any_ChangeInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_type_any_change = /** @type {((inputs?: Notifications_Type_Any_ChangeInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Type_Any_ChangeInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_type_any_change(inputs)
	return en_notifications_type_any_change(inputs)
});